import { useTranslation } from 'react-i18next';
import { SkippedReceiptDtoIn, SkippedReceiptReason } from '@/models/in/ReceiptsEmailResultDtoIn';
import styles from './ReceiptEmailDialog.module.css';

const REASONS: SkippedReceiptReason[] = ['NotReady', 'NotFound', 'NoAccess'];
// What the coordinator can do about it; nothing to suggest for a receipt of another fund
const HINTED: SkippedReceiptReason[] = ['NotReady', 'NotFound'];

interface SkippedReceiptsListProps {
  skipped: SkippedReceiptDtoIn[];
  /** The send was of one receipt: the sentence speaks of "the receipt" and drops the number */
  isSingleReceipt?: boolean;
}

/**
 * The receipts an email left out, a short block per reason: how many and why, their numbers, and
 * what to do. Before HAT-1444 they dropped out silently and the coordinator was told every receipt
 * had been sent.
 */
const SkippedReceiptsList = ({ skipped, isSingleReceipt = false }: SkippedReceiptsListProps) => {
  const { t } = useTranslation();
  if (skipped.length === 0) {
    return null;
  }

  return (
    <div className={styles.skippedList}>
      {REASONS.map((reason) => {
        const receiptIds = skipped.filter((s) => s.reason === reason).map((s) => s.receiptId);
        if (receiptIds.length === 0) {
          return null;
        }

        return (
          <div key={reason} className={styles.skippedGroup}>
            {isSingleReceipt ? (
              <p className="body-md-regular text-(--font-body-1)">{t(`skippedReceipts.${reason}Single`)}</p>
            ) : (
              <>
                <p className="body-md-regular text-(--font-body-1)">{t(`skippedReceipts.${reason}`, { count: receiptIds.length })}:</p>
                {/* Its own left-to-right line: inside a Hebrew sentence the commas between numbers jump around */}
                <p className="body-md-semibold text-(--font-body-1)" dir="ltr">
                  {receiptIds.join(', ')}
                </p>
              </>
            )}
            {HINTED.includes(reason) && <p className="body-sm-regular text-(--font-body-2)">{t(`skippedReceiptsHint.${reason}`)}</p>}
          </div>
        );
      })}
    </div>
  );
};

export default SkippedReceiptsList;
